import { render, staticRenderFns } from "./GoHome.vue?vue&type=template&id=ab0fdb5a&scoped=true&"
import script from "./GoHome.vue?vue&type=script&lang=js&"
export * from "./GoHome.vue?vue&type=script&lang=js&"
import style0 from "./GoHome.vue?vue&type=style&index=0&id=ab0fdb5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0fdb5a",
  null
  
)

export default component.exports